export const pageFooterVolunteeringLinksData = [
  { title: 'Volunteer in Seattle', href: '/en/volunteer-in-seattle-wa' },
  {
    title: 'Volunteer in San Jose',
    href: '/en/volunteer-in-san-jose',
  },
  {
    title: 'Volunteer in Boston',
    href: '/en/volunteer-in-boston',
  },
  {
    title: 'Volunteer in San Francisco',
    href: '/en/volunteer-in-san-francisco',
  },
  {
    title: 'Volunteer in Denver',
    href: '/en/volunteer-in-denver-co',
  },
  {
    title: 'Volunteer in Austin',
    href: '/en/volunteer-in-austin-tx',
  },
  {
    title: 'Volunteer in Virginia Beach',
    href: '/en/volunteer-in-virginia-beach-virginia',
  },
  {
    title: 'Volunteer in Chicago',
    href: '/en/volunteer-in-chicago',
  },
  {
    title: 'Volunteer in Madison',
    href: '/en/volunteer-in-madison-wisconsin',
  },
  {
    title: 'Volunteer in Miami',
    href: '/en/volunteer-in-miami',
  },
  {
    title: 'Volunteer in Nashville',
    href: '/en/volunteer-in-nashville-tn',
  },
  {
    title: 'Volunteer in Long Beach',
    href: '/en/volunteer-in-long-beach-ca',
  },
  {
    title: 'Volunteer in Minneapolis',
    href: '/en/volunteer-in-minneapolis-mn',
  },
  {
    title: 'Volunteer in New Orleans',
    href: '/en/volunteer-in-new-orleans-la',
  },
  {
    title: 'Volunteer in New York City',
    href: '/en/volunteer-in-new-york-city',
  },
  {
    title: 'Volunteer in Phoenix',
    href: '/en/volunteer-in-phoenix-az',
  },
  {
    title: 'Volunteer in Washington DC',
    href: '/en/volunteer-in-washington-dc',
  },
  {
    title: 'Volunteer in San Diego',
    href: '/en/volunteer-in-san-diego-ca',
  },
];
